import { makeStyles } from "@material-ui/core";

export const useStyleEmerSetting = makeStyles(theme => ({
    textShowImage:{
        minHeight: 40,
        display: 'flex',
        alignItems: 'center',
        maxWidth: '100%',
        overflow: 'auto',
        background: "#fafafe",
    },
    btnUpload:{
        minHeight: 40,
        display: 'flex',
        alignItems: 'center',
    }
}));